(function($) {
	'use strict';
	document.querySelectorAll('.mega-custom-icon').forEach(el => {
		const imgCSS = window.getComputedStyle(el, '::before');
		const imgCSSAfter = window.getComputedStyle(el, '::after');
		const imgUrl = imgCSS.backgroundImage.split('"')[1];
		el.style.setProperty('--content', imgCSS.backgroundImage);

		var bgImg = new Image();

		bgImg.src = imgUrl;
	});

	//	gsap.registerPlugin(ScrollTrigger);

	let scroll;
	function initLocoScroll() {
		if (document.querySelector('.disable-loco')) return;

		scroll = new LocomotiveScroll({
			el: document.querySelector('[data-scroll-container]'),
			smooth: true,
		});
	}

	initLocoScroll();

	if (scroll) {
		scroll.destroy();

		setTimeout(function() {
			scroll.init();
		}, 100);
	}

	let winW = window.innerWidth;

	const masthead = document.querySelector('.masthead');
	const trigger = document.querySelector('.menu-trigger');
	const searchpage = document.querySelector('.search-page');
	const support = document.querySelector('.support');

	const toggleMenu = status => {
		if (status == 'false') {
			trigger.classList.add('open');
			masthead.classList.add('open');
			support.classList.add('d-none');
			document.body.classList.add('no-scroll');
			trigger.setAttribute('aria-expanded', 'true');
		} else {
			document.querySelector('.mega-menu .primary-menu .search-form').classList.remove('d-none');
			trigger.classList.remove('open');
			masthead.classList.remove('open');
			support.classList.remove('d-none');
			document.body.classList.remove('no-scroll');
			trigger.setAttribute('aria-expanded', 'false');

			document.querySelectorAll('.primary-menu .menu-item-has-children').forEach(element => {
				element.classList.remove('open');
			});

			if (searchpage) {
				if (searchpage.classList.contains('open')) {
					searchpage.classList.remove('open');
					window.location.href = window.location.href.split('?')[0];
				}
			}
		}
	};

	trigger.setAttribute('aria-expanded', 'false');

	trigger.addEventListener('click', function() {
		let status = trigger.getAttribute('aria-expanded');
		toggleMenu(status);
	});

	// Focus input if Searchform is empty
	[].forEach.call(document.querySelectorAll('.search-form'), el => {
		el.addEventListener('submit', function(e) {
			var search = el.querySelector('input');
			if (search.value.length < 1) {
				e.preventDefault();
				search.focus();
			}
		});
	});

	if (document.querySelector('.search')) {
		masthead.classList.add('open');

		document.querySelector('.search-close').addEventListener('click', () => {
			document.body.classList.remove('no-scroll');
			setTimeout(function() {
				masthead.classList.remove('open');
			}, 250);

			if (searchpage.classList.contains('open')) {
				searchpage.classList.remove('open');
				window.location.href = window.location.href.split('?')[0];
			}
		});
	}

	if (scroll) {
		scroll.on('scroll', () => {
			ScrollTrigger.update;

			if (document.querySelector('.js-dark-mode')) {
				if (document.querySelector('.js-dark-mode').classList.contains('is-inview')) {
					document.querySelector('body').classList.add('bg-primary');

					document.querySelectorAll('.icon-light').forEach(el => {
						el.classList.add('active');
					});
					document.querySelectorAll('.icon-dark').forEach(el => {
						el.classList.remove('active');
					});
				} else {
					document.querySelector('body').classList.remove('bg-primary');

					document.querySelectorAll('.icon-light').forEach(el => {
						el.classList.remove('active');
					});
					document.querySelectorAll('.icon-dark').forEach(el => {
						el.classList.add('active');
					});
				}
			}

			if (document.querySelector('.single-guide')) {
				document.querySelectorAll('.guide-body .chapter').forEach(el => {
					let ID = el.dataset.scrollId;
					if (el.classList.contains('is-inview')) {
						document.querySelectorAll('.nav-chapter-links a').forEach(el => {
							el.classList.remove('active');
						});
						document.querySelector('.nav-chapter-links #' + ID).classList.add('active');
					} else {
						document.querySelector('.nav-chapter-links #' + ID).classList.remove('active');
					}
				});
			}
		});
	}

	document.querySelectorAll('.nav-chapter-links a').forEach(element => {
		element.addEventListener('click', e => {
			e.preventDefault();

			let ID = element.getAttribute('href');
			const target = document.querySelector(ID);

			scroll ? scroll.scrollTo(target) : '';
		});
	});

	document.querySelectorAll('.primary-menu .menu-item-has-children.parent-menu-item > a').forEach(el => {
		el.addEventListener('click', () => {
			if (el.parentNode.classList.contains('open')) {
				document.querySelector('.mega-menu .primary-menu .search-form').classList.remove('d-none');
				el.parentNode.classList.remove('open');

				el.parentNode.style.height = 'auto';
				el.parentNode.parentNode.style.height = 'auto';
			} else {
				document.querySelector('.mega-menu .primary-menu .search-form').classList.add('d-none');
				el.parentNode.classList.add('open');

				submenu = el.parentNode.querySelector('.sub-menu-container');

				if (winW < 768) {
					el.parentNodestyle.height = submenu.offsetHeight + 50 + 'px';
					el.parentNode.parentNode.style.height = submenu.offsetHeight + 50 + 'px';
				}
			}

			for (let sibling of el.parentNode.parentNode.children) {
				if (sibling !== el.parentNode) sibling.classList.remove('open');
			}
		});
	});

	document.querySelectorAll('.mega-menu-item-has-children').forEach(el => {
		el.addEventListener('mouseover', () => {
			document.body.classList.add('nav-overlay');
		});

		el.addEventListener('mouseout', () => {
			document.body.classList.remove('nav-overlay');
		});
	});

	const accItem = document.querySelector('.mega-menu .accordion-item');
	if (accItem) {
		let i = 0;

		document.querySelectorAll('.mega-menu .accordion-item').forEach(el => {
			if (!el.parentNode.hasAttribute('id')) {
				const accID = 'top-nav-accordion' + i++;
				el.parentNode.setAttribute('id', accID);
			}

			currentaccID = el.parentNode.getAttribute('id');

			elmAnchor = el.querySelector('a');
			elmSubMenu = el.querySelector('.sub-menu-container');

			elmAnchor.setAttribute('data-bs-toggle', 'collapse');
			elmAnchor.setAttribute('aria-expanded', '');

			elmSubMenu.setAttribute('data-bs-parent', '#' + currentaccID);
			const elmID = elmAnchor
				.getAttribute('data-bs-target')
				.replace(/[^a-zA-Z0-9# ]/g, '')
				.split(' ')
				.join('');
			elmAnchor.setAttribute('data-bs-target', elmID);
			const itemID = elmAnchor.getAttribute('data-bs-target').replace(/^#/, '');
			elmSubMenu.setAttribute('id', itemID);

			if (elmSubMenu.classList.contains('show-accordion')) {
				elmAnchor.setAttribute('aria-expanded', 'true');
				elmSubMenu.classList.add('show');
			} else {
				elmSubMenu.classList.add('collapse');
			}
		});
	}

	setTimeout(function() {
		if (document.querySelector('.njt-nofi-container')) {
			document.querySelector('.masthead').style.top = document.querySelector('.njt-nofi-container').offsetHeight - 1 + 'px';
		}
	}, 300);

	if (document.querySelector('.njt-nofi-close-button')) {
		document.querySelector('.njt-nofi-close-button').addEventListener('click', () => {
			document.querySelector('.masthead').style.top = '0px';
		});
	}

	document.querySelectorAll('.scroll-to-section').forEach(element => {
		element.addEventListener('click', e => {
			e.preventDefault();

			let ID = element.getAttribute('href');
			const target = document.querySelector(ID);

			scroll ? scroll.scrollTo(target) : '';
		});
	});

	ScrollTrigger.scrollerProxy('[data-scroll-container]', {
		scrollTop(value) {
			if (scroll) {
				return arguments.length ? scroll.scrollTo(value, 0, 0) : scroll.scroll.instance.scroll.y;
			}
		}, // we don't have to define a scrollLeft because we're only scrolling vertically.
		getBoundingClientRect() {
			return { top: 0, left: 0, width: window.innerWidth, height: window.innerHeight };
		},
		// LocomotiveScroll handles things completely differently on mobile devices - it doesn't even transform the container at all! So to get the correct behavior and avoid jitters, we should pin things with position: fixed on mobile. We sense it by checking to see if there's a transform applied to the container (the LocomotiveScroll-controlled element).
		pinType: document.querySelector('[data-scroll-container]').style.transform ? 'transform' : 'fixed',
	});

	if (!scroll) {
		var prevScrollpos = window.pageYOffset;

		window.onscroll = function() {
			var currentScrollPos = window.pageYOffset;
			var sticky = document.querySelector('.masthead').scrollHeight;

			if (prevScrollpos > currentScrollPos) {
				document.querySelector('.masthead').classList.remove('hide-header');
				document.querySelector('.masthead').classList.add('show');
			} else {
				document.querySelector('.masthead').classList.remove('show');
				document.querySelector('.masthead').classList.add('hide-header');
			}
			if (window.pageYOffset < sticky) {
				document.querySelector('.masthead').classList.remove('show');
			}

			prevScrollpos = currentScrollPos;
		};
	}

	const showAnim = gsap
		.from('.masthead', {
			yPercent: -100,
			duration: 0.15,
		})
		.progress(1);

	ScrollTrigger.create({
		start: 'top top',
		end: 999999,
		scroller: document.querySelector('[data-scroll-container]'),
		onUpdate: self => {
			if (self.direction === -1) {
				if (self.progress > 0) {
					masthead.classList.add('show');
				} else {
					masthead.classList.remove('show');
				}
				showAnim.play();
			} else {
				masthead.classList.remove('show');
				showAnim.reverse();
			}
		},
	});

	scroll ? ScrollTrigger.addEventListener('refresh', () => scroll.update()) : '';

	// after everything is set up, refresh() ScrollTrigger and update LocomotiveScroll because padding may have been added for pinning, etc.
	ScrollTrigger.refresh();

	if (document.querySelector('.features-slider')) {
		const featuresSlider = new Splide('.features-slider', {
			type: 'fade',
			pagination: false,
			speed: 450,
			arrows: false,
		});

		const tabs = document.querySelectorAll('.features-tab__item');
		const bar = document.querySelector('.features-tab__bar');

		let current;

		for (var i = 0; i < tabs.length; i++) {
			initTab(tabs[i], i);
		}

		function initTab(tab, index) {
			tab.addEventListener('click', () => {
				featuresSlider.go(index);
			});
		}

		featuresSlider.on('mounted move', function() {
			let tab = tabs[featuresSlider.index];

			if (tab) {
				if (current) {
					current.classList.remove('-active');
				}

				tab.classList.add('-active');
				current = tab;
				bar.style.left = current.offsetLeft + 'px';
			}
		});

		featuresSlider.mount();

		const dropdownInput = document.querySelector('.dropdown__input');
		const dropdownList = document.querySelector('.dropdown__list');

		document.body.addEventListener(
			'click',
			() => {
				dropdownInput.parentElement.classList.remove('-open');
			},
			true
		);

		dropdownInput.addEventListener('click', e => {
			e.preventDefault();
			e.stopPropagation();
			dropdownInput.parentElement.classList.add('-open');
		});

		dropdownList.childNodes.forEach(element => {
			element.addEventListener('click', () => {
				dropdownInput.value = element.textContent;
			});
		});

		dropdownList.addEventListener('click', e => {
			dropdownInput.value = e.target.textContent;
		});
	}

	if (document.querySelector('.micro-features-slider')) {
		document.querySelectorAll('.micro-features-slider').forEach(element => {
			let microFeaturesSlider = new Splide(element, {
				type: 'fade',
				pagination: false,
				speed: 450,
				arrows: false,
				drag: false,
			});

			let tabs = element.closest('.offering').querySelectorAll('.micro-features-tab__item');
			let current;

			for (var i = 0; i < tabs.length; i++) {
				initTab(tabs[i], i);
			}

			function initTab(tab, index) {
				tab.addEventListener('click', function() {
					microFeaturesSlider.go(index);
				});
			}

			microFeaturesSlider.on('mounted move', function() {
				let tab = tabs[microFeaturesSlider.index];

				if (tab) {
					if (current) {
						current.classList.remove('-active');
					}

					tab.classList.add('-active');
					current = tab;
				}
			});

			microFeaturesSlider.mount();
		});
	}

	if (document.querySelector('.partners-slider')) {
		const partnersSlider = new Splide('.partners-slider', {
			type: 'fade',
			pagination: false,
			speed: 450,
			arrows: false,
		});

		const tabs = document.querySelectorAll('.partners-tab__item');

		let current;

		for (var i = 0; i < tabs.length; i++) {
			initTab(tabs[i], i);
		}

		function initTab(tab, index) {
			tab.addEventListener('click', () => {
				partnersSlider.go(index);
			});
		}

		partnersSlider.on('mounted move', function() {
			let tab = tabs[partnersSlider.index];

			if (tab) {
				if (current) {
					current.classList.remove('-active');
				}

				tab.classList.add('-active');
				current = tab;
			}
		});

		partnersSlider.mount();

		const dropdownInput = document.querySelector('.dropdown__input');
		const dropdownList = document.querySelector('.dropdown__list');

		document.body.addEventListener(
			'click',
			() => {
				dropdownInput.parentElement.classList.remove('-open');
			},
			true
		);

		dropdownInput.addEventListener('click', e => {
			e.preventDefault();
			e.stopPropagation();
			dropdownInput.parentElement.classList.add('-open');
		});

		dropdownList.childNodes.forEach(element => {
			element.addEventListener('click', () => {
				dropdownInput.value = element.textContent;
			});
		});

		dropdownList.addEventListener('click', e => {
			dropdownInput.value = e.target.textContent;
		});
	}

	if (document.querySelector('.testimonials-slider')) {
		new Splide('.testimonials-slider', {
			type: 'fade',
			pagination: false,
			arrowPath: 'M35.4,20c0,0.7-0.3,1.4-0.9,2L17.4,39.1c-1.1,1.1-2.9,1.1-4,0c-1.1-1.1-1.1-2.9,0-4L28.6,20L13.4,4.9c-1.1-1.1-1.1-2.9,0-4s2.9-1.1,4,0L34.6,18C35.1,18.6,35.4,19.3,35.4,20z',
			speed: 450,
			rewind: true,
		}).mount();
	}

	if (document.querySelector('.posts-slider')) {
		new Splide('.posts-slider', {
			type: 'loop',
			pagination: false,
			arrowPath: 'M35.4,20c0,0.7-0.3,1.4-0.9,2L17.4,39.1c-1.1,1.1-2.9,1.1-4,0c-1.1-1.1-1.1-2.9,0-4L28.6,20L13.4,4.9c-1.1-1.1-1.1-2.9,0-4s2.9-1.1,4,0L34.6,18C35.1,18.6,35.4,19.3,35.4,20z',
			perPage: 2,
			speed: 750,
			breakpoints: {
				768: {
					perPage: 1,
					speed: 600,
				},
			},
		}).mount();
	}

	if (document.querySelector('.events-slider')) {
		new Splide('.events-slider', {
			type: 'slide',
			pagination: false,
			arrowPath: 'M35.4,20c0,0.7-0.3,1.4-0.9,2L17.4,39.1c-1.1,1.1-2.9,1.1-4,0c-1.1-1.1-1.1-2.9,0-4L28.6,20L13.4,4.9c-1.1-1.1-1.1-2.9,0-4s2.9-1.1,4,0L34.6,18C35.1,18.6,35.4,19.3,35.4,20z',
			perPage: 2,
			speed: 750,
			breakpoints: {
				768: {
					perPage: 1,
					speed: 600,
				},
			},
		}).mount();
	}

	if (document.querySelector('.headlines-slider')) {
		new Splide('.headlines-slider', {
			type: 'loop',
			pagination: false,
			arrowPath: 'M35.4,20c0,0.7-0.3,1.4-0.9,2L17.4,39.1c-1.1,1.1-2.9,1.1-4,0c-1.1-1.1-1.1-2.9,0-4L28.6,20L13.4,4.9c-1.1-1.1-1.1-2.9,0-4s2.9-1.1,4,0L34.6,18C35.1,18.6,35.4,19.3,35.4,20z',
			perPage: 3,
			speed: 750,
			breakpoints: {
				768: {
					perPage: 1,
					speed: 600,
				},
			},
		}).mount();
	}

	//Announcements Carousel
	if (document.querySelector('.announcements')) {
		new Splide('.announcements-slider', {
			type: 'fade',
			rewind: true,
			perPage: 1,
			autoplay: true,
			pagination: false,
			arrowPath: 'M35.4,20c0,0.7-0.3,1.4-0.9,2L17.4,39.1c-1.1,1.1-2.9,1.1-4,0c-1.1-1.1-1.1-2.9,0-4L28.6,20L13.4,4.9c-1.1-1.1-1.1-2.9,0-4s2.9-1.1,4,0L34.6,18C35.1,18.6,35.4,19.3,35.4,20z',
			interval: 7000,
			speed: 550,
		}).mount();
	}

	if (document.querySelector('.single-slider')) {
		new Splide('.single-slider', {
			type: 'slide',
			pagination: false,
			arrowPath: 'M35.4,20c0,0.7-0.3,1.4-0.9,2L17.4,39.1c-1.1,1.1-2.9,1.1-4,0c-1.1-1.1-1.1-2.9,0-4L28.6,20L13.4,4.9c-1.1-1.1-1.1-2.9,0-4s2.9-1.1,4,0L34.6,18C35.1,18.6,35.4,19.3,35.4,20z',
			speed: 750,
		}).mount();
	}

	if (document.querySelector('.wide-card-slider')) {
		new Splide('.wide-card-slider', {
			type: 'loop',
			pagination: false,
			arrowPath: 'M35.4,20c0,0.7-0.3,1.4-0.9,2L17.4,39.1c-1.1,1.1-2.9,1.1-4,0c-1.1-1.1-1.1-2.9,0-4L28.6,20L13.4,4.9c-1.1-1.1-1.1-2.9,0-4s2.9-1.1,4,0L34.6,18C35.1,18.6,35.4,19.3,35.4,20z',
			perPage: 3,
			perMove: 1,
			gap: '1.25rem',
			padding: '5rem',
			speed: 750,
			breakpoints: {
				1200: {
					padding: '4rem',
					gap: '1rem',
				},
				992: {
					fixedWidth: '',
					padding: '4rem',
					perPage: 2,
					gap: '1rem',
				},
				768: {
					fixedWidth: '',
					perPage: 2,
					padding: '2rem',
					speed: 600,
					gap: '1rem',
				},
				576: {
					perPage: 1,
					padding: '',
					speed: 600,
				},
			},
		}).mount();
	}

	if (document.querySelector('.icon-card-slider')) {
		new Splide('.icon-card-slider', {
			type: 'loop',
			pagination: false,
			arrowPath: 'M35.4,20c0,0.7-0.3,1.4-0.9,2L17.4,39.1c-1.1,1.1-2.9,1.1-4,0c-1.1-1.1-1.1-2.9,0-4L28.6,20L13.4,4.9c-1.1-1.1-1.1-2.9,0-4s2.9-1.1,4,0L34.6,18C35.1,18.6,35.4,19.3,35.4,20z',
			perPage: 3,
			perMove: 1,
			gap: '1.25rem',
			padding: '5rem',
			speed: 450,
			breakpoints: {
				1200: {
					padding: '4rem',
					gap: '1rem',
				},
				992: {
					fixedWidth: '',
					padding: '4rem',
					perPage: 2,
					gap: '1rem',
				},
				768: {
					fixedWidth: '',
					perPage: 2,
					padding: '2rem',
					speed: 450,
					gap: '1rem',
				},
				576: {
					perPage: 1,
					padding: '',
					speed: 450,
				},
			},
		}).mount();
	}

	if (document.querySelector('.icon-card-slider-4')) {
		new Splide('.icon-card-slider-4', {
			type: 'loop',
			pagination: false,
			arrowPath: 'M35.4,20c0,0.7-0.3,1.4-0.9,2L17.4,39.1c-1.1,1.1-2.9,1.1-4,0c-1.1-1.1-1.1-2.9,0-4L28.6,20L13.4,4.9c-1.1-1.1-1.1-2.9,0-4s2.9-1.1,4,0L34.6,18C35.1,18.6,35.4,19.3,35.4,20z',
			perPage: 4,
			perMove: 1,
			gap: '1.25rem',
			padding: '7rem',
			speed: 450,
			breakpoints: {
				1200: {
					padding: '4rem',
					gap: '1rem',
				},
				992: {
					fixedWidth: '',
					padding: '4rem',
					perPage: 2,
					gap: '1rem',
				},
				768: {
					fixedWidth: '',
					perPage: 2,
					padding: '2rem',
					speed: 450,
					gap: '1rem',
				},
				576: {
					perPage: 1,
					padding: '',
					speed: 450,
				},
			},
		}).mount();
	}

	if (document.querySelector('.image-overlay-card-slider')) {
		new Splide('.image-overlay-card-slider', {
			type: 'loop',
			pagination: false,
			arrowPath: 'M35.4,20c0,0.7-0.3,1.4-0.9,2L17.4,39.1c-1.1,1.1-2.9,1.1-4,0c-1.1-1.1-1.1-2.9,0-4L28.6,20L13.4,4.9c-1.1-1.1-1.1-2.9,0-4s2.9-1.1,4,0L34.6,18C35.1,18.6,35.4,19.3,35.4,20z',
			perPage: 4,
			perMove: 1,
			gap: '1.25rem',
			padding: '5rem',
			speed: 450,
			breakpoints: {
				1600: {
					perPage: 3
				},
				1200: {
					perPage: 3,
					padding: '4rem',
					gap: '1rem',
				},
				992: {
					fixedWidth: '',
					padding: '4rem',
					perPage: 2,
					gap: '1rem',
				},
				768: {
					fixedWidth: '',
					perPage: 2,
					padding: '2rem',
					speed: 450,
					gap: '1rem',
				},
				576: {
					perPage: 1,
					padding: '',
					speed: 450,
				},
			},
		}).mount();
	}

	if (document.querySelector('.masonry')) {
		let macy = Macy({
			container: '.masonry',
			trueOrder: false,
			waitForImages: false,
			margin: 16,
			columns: 3,
			breakAt: {
				768: 2,
				360: 1,
			},
		});
	}

	if (document.querySelector('.jobs-wrapper')) {
		document.querySelectorAll('.job-link a').forEach(el => {
			let oldLink = el.href,
				newLink = oldLink.replace('careers', 'careers-detail');

			el.setAttribute('href', newLink);
		});
	}

	if (document.querySelector('#grnhse_app')) {
		setTimeout(function() {
			ScrollTrigger.refresh();
		}, 2000);
	}

	const listenWidth = () => {
		winW = window.innerWidth;

		if (document.querySelector('.features-slider')) {
			const bar = document.querySelector('.features-tab__bar');
			const currentTab = document.querySelector('.features-tab__item.-active');

			bar.style.left = currentTab.offsetLeft + 'px';
		}

		if (document.querySelector('.cards-only')) {
			let cardTitleMaxH;

			equalHeight(cardTitleMaxH, $('.cards-only .card-body h3'), 768);
		}
	};

	window.onresize = listenWidth;
	/*[].forEach.call(document.querySelectorAll(".menu-cont h5"), el => {
    el.addEventListener('click', function(e) {
			this.parentNode.classList.toggle("open");
    });
	}); */

	function adjustCollapseView() {
		const desktopView = document.documentElement.clientWidth;

		if (desktopView >= 576) {
			document.querySelectorAll('.links-cont').forEach(el => {
				el.classList.remove('collapse');
				el.classList.add('show');
			});

			document.querySelectorAll('#accordion h5').forEach(el => {
				el.removeAttribute('data-bs-toggle');
			});
		} else {
			[].forEach.call(document.querySelectorAll('#accordion h5'), el => {
				const att = document.createAttribute('data-bs-toggle');
				att.value = 'collapse';
				el.setAttributeNode(att);
			});

			[].forEach.call(document.querySelectorAll('#accordion .links-cont'), el => {
				const att = document.createAttribute('data-bs-parent');
				att.value = '#accordion';
				el.setAttributeNode(att);
				el.classList.remove('show');
				el.classList.add('collapse');
			});

			const attri = document.createAttribute('aria-expanded');
			attri.value = 'true';
			document.querySelector('.menu-cont h5').setAttributeNode(attri);
			document.querySelector('.links-cont').classList.add('show');
		}
	}

	adjustCollapseView();
	window.addEventListener('resize', function() {
		adjustCollapseView();
	});

	//add class 'hard-break' to footer's heading
	document.querySelector('.brand-info h2').classList.add('hard-break');

	const urlParams = new URLSearchParams(window.location.search); //get all parameters
	const search = urlParams.get('s');

	if (search) {
		searchpage.classList.add('open');
		document.querySelector('.custom-logo-link').style.display = 'none';
		document.querySelector('.custom-logo-link.-reverse').style.display = 'inline-block';
		document.querySelectorAll('.menu-trigger .bar').forEach(el => {
			el.classList.add('bg-white');
		});
		document.querySelector('.menu-trigger').style.color = '#fff';
		trigger.classList.add('open');
		document.body.classList.add('no-scroll');
		trigger.setAttribute('aria-expanded', 'true');
	}

	const params = new URLSearchParams(window.location.search);
	const utm_params = [];

	params.forEach(function(value, key) {
		if (key.startsWith('utm_')) {
			utm_params.push(key + '=' + value);
		} else if (key == 'modal') {
			if (value == 'open') {
				setTimeout(function() {
					$('#contactModal').modal('show');
				}, 500);
			}
		}
	});
	let utm_search = utm_params.join('&');

	if (!!utm_search) {
		let anchorElements = document.querySelectorAll('a[href]');

		anchorElements.forEach(anchor => {
			anchor.addEventListener('click', () => {
				let anchorHref = anchor.getAttribute('href');

				if (/^#/.test(anchorHref)) {
					anchorHref = utm_search + anchorHref;
				} else {
					anchor.href = combinedUtmUrl(anchor.href, utm_search);
				}
			});
		});
	}

	function buildUrl(fromURL, fromQuery) {
		const url = new URL(fromURL);

		const query = new URLSearchParams(fromQuery);
		for (const [key, value] of query) {
			url.searchParams.set(key, value);
		}

		return url.toString();
	}

	function combinedUtmUrl(fromURL, fromQuery) {
		const url = buildUrl(fromURL, fromQuery);
		return `${url}`;
	}

	document.querySelectorAll('.highlight-last-text').forEach(el => {
		const title = el.innerText.split(' ');
		const highlight = ' <span class="text-secondary">' + title.splice(-2).join(' ') + '</span>';
		el.innerHTML = title.join(' ') + highlight;
	});

	function equalHeight(maxH, $elem, breakpoint) {
		$elem.css('height', 'auto');

		console.log('height');

		maxH = 0;

		if (winW >= breakpoint) {
			$elem.each(function(i, el) {
				if (maxH < $(el).innerHeight()) {
					maxH = $(el).innerHeight();
				}
			});

			$elem.css('height', maxH);
		} else {
			$elem.css('height', 'auto');
		}
	}

	//jquery

	if (document.querySelector('.cards-only')) {
		let cardTitleMaxH;

		equalHeight(cardTitleMaxH, $('.cards-only .card-body h3'), 768);
	}

	if (document.querySelector('#filter_by')) {
		document.querySelector('#filter_by').addEventListener('click', () => {
			document.querySelector('.filter-popup').classList.add('show');
			$('.filter-popup').slideDown('fast');
		});

		document.querySelector('.filter-popup').addEventListener('click', function(e) {
			e.stopPropagation();
		});

		document.querySelector('.filter-popup .close').addEventListener('click', () => {
			document.querySelector('.filter-popup').classList.remove('show');
			$('.filter-popup').slideUp('fast');
		});

		const popup = document.querySelector('.filter-popup');

		document.onclick = function(e) {
			if (popup.classList.contains('show') && e.target.id !== 'filter_by') {
				document.querySelector('.filter-popup').classList.remove('show');
				$('.filter-popup').slideUp('fast');
			}
		};

		document.querySelector('.searchandfilter ul').classList.add('filter-layout');

		$(document).on('sf:ajaxstart', '.searchandfilter', function() {
			ScrollTrigger.refresh();
		});

		$(document).on('sf:init', '.searchandfilter', function() {
			scroll ? scroll.update() : ' ';
		});

		$(document).on('sf:ajaxfinish', '.searchandfilter', function() {
			//load your JS scripts here again
			if ($('.sf-field-taxonomy-Offering ul').children().length < 2) {
				$('.sf-field-taxonomy-Offering ul').css('display', 'none');
				$('.sf-field-taxonomy-Offering h4').css('display', 'none');
			} else {
				$('.sf-field-taxonomy-Offering ul').css('display', 'block');
			}

			const nextURL = window.location.href + (window.location.href.indexOf('?') === -1 ? '?' : '&') + utm_search;
			window.history.replaceState('', '', nextURL);

			getResourcesTitle();
		});

		if ($('.sf-field-taxonomy-Offering ul').children().length < 2) {
			$('.sf-field-taxonomy-Offering ul').css('display', 'none');
			$('.sf-field-taxonomy-Offering h4').css('display', 'none');
		} else {
			$('.sf-field-taxonomy-Offering ul').css('display', 'block');
		}

		getResourcesTitle();
		
		// Change result title based on resource type
		function getResourcesTitle() {
			const urlParams = new URLSearchParams(window.location.search);
			const newURLParams = urlParams.get('post_types')

			let headerContainer = document.querySelector('.all-resources-header');
      let headerTitle = headerContainer.querySelector('h2');

			if(newURLParams == 'post') {
				headerTitle.innerHTML = "All Blog Posts";
			} else if (newURLParams == 'whitepaper') {
				headerTitle.innerHTML = "All Whitepapers";
			} else if (newURLParams == 'case-study') {
				headerTitle.innerHTML = "All Case Studies";
			} else {
				headerTitle.innerHTML = "All Resources";
			}
		}
	}

	if (document.querySelector('#jobs')) {
		$('.btn-job').css('display', 'block');
	}

	/*
const filterPopover = new bootstrap.Popover(document.querySelector('#filter_by'), {
  container: 'body',
  title: 'Filter',
  html: true,
  placement: 'bottom',
  sanitize: false,
  content() {
    return document.querySelector('.filter-popover').innerHTML;
  }
});

$(document).on('click','.close',function(){
  $('#filter_by').popover('hide');
});*/
})(jQuery);
